import { getCurrentInstance as c, computed as r } from "vue";
import f from "./td-longtail-vue-components86.js";
const g = (e, n) => {
  const i = {};
  return Object.keys(e).forEach((t) => {
    n.includes(t) || (i[t] = e[t]);
  }), i;
};
function x(e, n) {
  const i = c(), t = r(() => {
    const a = i?.proxy?.$options?._componentTag, u = e.idPrefix ? `${e.idPrefix}-` : "", o = e.id || // @ts-ignore
    [a, f(`${u}${e.label || e.name || ""}`)].filter(Boolean).join("-");
    return o || console.error('Input has no id. Enter a prop "id"', a), o;
  }), s = r(() => ({
    id: t.value,
    errorMessage: e.errorMessage,
    hintMessage: e.hintMessage,
    readonly: e.readonly,
    disabled: e.disabled,
    required: e.required,
    label: e.label,
    labelClass: e.labelClass,
    large: e.large,
    medium: e.medium,
    inlineLabel: e.inlineLabel,
    value: e.value,
    hasFixedValue: e.hasFixedValue
  })), d = r(() => ({
    ...g(e, [
      "label",
      "labelClass",
      "errorMessage",
      "hintMessage",
      "class",
      "inputProps",
      "options",
      "idPrefix"
    ]),
    ...e.inputProps || {}
  })), l = r(() => i?.proxy?.$refs?.primaryInput);
  return {
    primaryInput: l,
    inputId: t,
    inputWrapperProps: s,
    inputFieldProps: d,
    onInput: (a) => {
      const u = a?.target;
      n && n("input", u?.value);
    },
    onFocus: () => {
      n && n("focus");
    },
    focus: () => {
      if (!l.value) throw new Error("Input does not support focus");
      l.value.focus(), n && n("focus");
    }
  };
}
export {
  x as useLabeledInput
};
